import React from "react";
import { Row, Col, Modal, Button } from "react-bootstrap";
import UserAllOrderCard from "./UserAllOrderCard";
import Cookies from "js-cookie";
import UserGetOrdersHook from "../../hook/user/UserGetOrdersHook";
import { GiReturnArrow } from "react-icons/gi";

import { t } from "i18next";
import { useSelector } from "react-redux";
import axios from "axios";
import { useParams, useSearchParams, Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useState } from "react";

const UserAllOrderItem = ({ orderItem,setLoading,loading  }) => {
  //  const [success,setSuccess] = useState(searchParams.get("success"))
  // console.log('searchParams')
  // console.log(success)
  const [
    username,
    result,
    orderData,
    noPages,
    onPress,
    clickHandler,
    handlePrintShipments,
    user,
    showModalReturnProduct,
    description,
    show,
    onChangeDescription,
    handleCloseModel,
    saveReturnProduct,
  ] = UserGetOrdersHook();

  const res = useSelector((state) => state.orderReducer.ordersByUser);

  // console.log('reeeeeeeeeeeeees');
  // console.log(res);
  //const updateOrder=useSelector((state)=>state.orderReducer.updateOrder);

  // console.log('updateOrder');
  // console.log(updateOrder);

  const settingsRes = useSelector((state) => state.settingsReducers.settings);
  const currencytype =
    Cookies.get("i18next") === "ar"
      ? settingsRes.data?.defaultCurrancy.ar
      : settingsRes.data?.defaultCurrancy.en;
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "numeric", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  // console.log('orderItem.totalPrice');
  // console.log(orderItem);

  // let check=orderItem.orderItems.find(el=>el.refund=='pending');

  // console.log('check',check);

  // if(check?._id) return;

  return (
    <div className="user-order-card bg-white p-4 rounded-4 shadow-sm mb-4 border-0 position-relative" style={{ border: '1px solid rgba(0,0,0,0.05)' }}>
      <Modal show={show} onHide={handleCloseModel}>
        <Modal.Header>
          <Modal.Title>
            <div className="font fw-bold" style={{ color: 'var(--primary-color)' }}>{t("من فضلك أدخل سبب الإسترجاع ")}</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="font">
            <textarea
              id="description"
              onChange={onChangeDescription}
              value={description}
              className="form-control p-3 mt-2 rounded-3 shadow-none bg-light border-0"
              rows="4"
              placeholder={t("سبب الإسترجاع")}
            />
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button
            variant="primary"
            className="font rounded-pill px-4 py-2"
            style={{ background: 'var(--primary-gradient)', border: 'none' }}
            onClick={() => saveReturnProduct()}
          >
            {t("Save Changes")}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Header section */}
      <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 border-bottom pb-3">
        <div className="mb-2 mb-md-0">
          <h5 className="mb-1" style={{ color: 'var(--primary-color)', fontWeight: 800 }}>
            {t("order number")} #{orderItem.orderNumber}
          </h5>
          <span className="text-muted" style={{ fontSize: '13px' }}>
            <i className="fa-regular fa-calendar me-2"></i>{formatDate(orderItem.createdAt)}
          </span>
        </div>
        <div className="d-flex gap-2 align-items-center">
          <span className="badge bg-light text-secondary px-3 py-2 border rounded-pill" style={{ fontSize: '12px' }}>
            {orderItem.orderStatusId?.nameAr || "قيد التنفيذ"}
          </span>
          <span className={`badge px-3 py-2 rounded-pill ${orderItem.isPaid ? 'bg-success' : 'bg-warning text-dark'}`} style={{ fontSize: '12px' }}>
            {orderItem.isPaid === true ? t("paid") : t("not paid")}
          </span>
        </div>
      </div>

      {/* Items List */}
      <div className="order-items-list mb-4">
        {orderItem?.orderItems?.length > 0 &&
          orderItem.orderItems.map((el) => {
            return (
              <UserAllOrderCard key={el._id} item={el} setLoading={setLoading} loading={loading} />
            );
          })}
      </div>

      {/* Footer / Actions */}
      <div className="d-flex flex-wrap justify-content-between align-items-center bg-light p-3 rounded-3">
        <div className="d-flex flex-column mb-3 mb-md-0">
          <div className="text-muted small mb-1">
            <strong>طريقة الدفع: </strong> {orderItem?.paymentMethodId?.nameAr}
          </div>
          <div className="fs-5 fw-bold" style={{ color: 'var(--primary-color)' }}>
            {t("Total")}: {(Number(orderItem.totalPrice).toFixed(2))} {currencytype}
          </div>
        </div>
        
        <div className="d-flex flex-wrap gap-2">
          {orderItem?.shipmentReferenceId && (
            <button className="btn btn-outline-secondary btn-sm rounded-pill px-3 py-2 d-flex align-items-center shadow-sm" onClick={() => handlePrintShipments(orderItem._id)}>
              <i className="fa-solid fa-truck me-2"></i> طباعه بوليصه الشحن
            </button>
          )}

          <Link to={`/invoice/${orderItem._id}`} target="_blank" className="btn-invoice-modern">
            <i className="fa-solid fa-print"></i> {t("View the bill")}
          </Link>

          {user?.role === "user" && (
            <button
              onClick={() => showModalReturnProduct(orderItem?.orderNumber)}
              className="btn-return-modern"
            >
              <GiReturnArrow size={16} /> استرجاع الطلب
            </button>
          )}
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default UserAllOrderItem;
